import { useCallback, useEffect } from 'react';

import { ResponseUserData } from '@/api/types';

interface IUseGAUserId {
  clearUserId: () => void;
}

export function useGAUserId(uid?: ResponseUserData['data']['uid']): IUseGAUserId {
  useEffect(() => {
    // @ts-ignore
    if (!uid || !window.gtag) return;
    // @ts-ignore
    window.gtag('config', {
      user_id: uid,
    });
  }, [uid]);

  const clearUserId = useCallback(() => {
    // @ts-ignore
    if (!window.gtag) return;
    // @ts-ignore
    window.gtag('config', { user_id: null });
  }, []);

  return { clearUserId };
}
